module.exports = __webpack_public_path__ + "static/media/36.fbf9dd12.mp3";